
import { useParams } from "react-router-dom";
import JobReview2 from "../../../features/employerDashboard/components/JobDetail";

export function JobSingle2Page() {
    const { uuid } = useParams();
    return (
      <div>
        <JobReview2 uuid={uuid} />
      </div>
    );
  }